<app-modal [hideClose]="true" (save)="saveSupplyPrice()">
  <main>
    <h1 class="h5 f-weight--600 m-b--16" i18n>Set price for rental of technical equipment</h1>
    <p class="m-b--28 f-size--16" i18n>The sum will be added to the final price</p>
    <form [formGroup]="supplyPriceForm">
      <app-price-input formControlName="price" [currencyShorthand]="booking.dates[0].priceCurrency"></app-price-input>
    </form>
  </main>
</app-modal>
